import { DemandeHabilitationStatutEnum } from '@graphql/generated';
import { HabilitationStatut } from '@lib/models/demande-habilitation/types/habilitation-statut.type';

export class DemandeHabilitationStatutMapper {
  public static toGraphQl(
    input: HabilitationStatut | null
  ): DemandeHabilitationStatutEnum | undefined {
    if (!input) return undefined;
    if (input === 'verrouille') {
      throw new Error(
        'The local locked status cannot be persisted as an habilitation status.'
      );
    }

    const mapping: Partial<
      Record<Exclude<HabilitationStatut, 'verrouille'>, DemandeHabilitationStatutEnum>
    > = {
      a_affecter: DemandeHabilitationStatutEnum.AAffecter,
      a_controler: DemandeHabilitationStatutEnum.AControler,
      nc_traitee: DemandeHabilitationStatutEnum.NcTraitee,
      annule: DemandeHabilitationStatutEnum.Annule,
      expire: DemandeHabilitationStatutEnum.Expire,
      nc_a_traiter: DemandeHabilitationStatutEnum.NcATraiter,
      refuse: DemandeHabilitationStatutEnum.Refuse,
      controle_en_cours: DemandeHabilitationStatutEnum.ControleEnCours,
      valide: DemandeHabilitationStatutEnum.Valide,
      validation_en_cours: DemandeHabilitationStatutEnum.ValidationEnCours,
      action_consultant: 'ACTION_CONSULTANT' as DemandeHabilitationStatutEnum,
      action_backoffice: 'ACTION_BACKOFFICE' as DemandeHabilitationStatutEnum,
      attente_service_externe: 'ATTENTE_SERVICE_EXTERNE' as DemandeHabilitationStatutEnum,
      pret: DemandeHabilitationStatutEnum.Pret,
    };
    return mapping[input];
  }

  public static fromGraphQl(
    input: DemandeHabilitationStatutEnum | null | undefined
  ): HabilitationStatut {
    if (!input) {
      throw new Error('An habilitation status is required.');
    }

    const mapping: Record<string, HabilitationStatut> = {
      A_AFFECTER: 'a_affecter',
      A_CONTROLER: 'a_controler',
      CONTROLE_EN_COURS: 'controle_en_cours',
      NC_TRAITEE: 'nc_traitee',
      ANNULE: 'annule',
      EXPIRE: 'expire',
      NC_A_TRAITER: 'nc_a_traiter',
      REFUSE: 'refuse',
      VALIDE: 'valide',
      VALIDATION_EN_COURS: 'validation_en_cours',
      EN_COURS: 'pret',
      PRET: 'pret',
      ACTION_CONSULTANT: 'action_consultant',
      ACTION_BACKOFFICE: 'action_backoffice',
      ATTENTE_SERVICE_EXTERNE: 'attente_service_externe',
    };
    const status = mapping[input];
    if (!status) {
      throw new Error('Unsupported habilitation status: ' + String(input));
    }
    return status;
  }
}
